import React, { useEffect, useState } from 'react'
import JobAction from '../../import/actions/JobAction'
import { useDispatch } from 'react-redux'
import i18n from '../../simple-react-i18n'
import { push } from '@lagunovsky/redux-react-router'
import { getFullDate } from '../../utils/DateUtil'
import { Typography, Grid, Box, Stack } from '@mui/material'
import { orderBy } from 'lodash'
import MessageCard from '../../components/card/MessageCard'
import HomeAction from '../../home/actions/HomeAction'
import { IMPORT_FORMATS } from '../../import/constants/JobFormat'

const GREY_BACKGROUND = '#f5f5f5'
const NotifsTreatement = () => {
    const dispatch = useDispatch()
    const [jobBookmarks, setJobBookmarks] = useState([])

    useEffect(() => {
        dispatch(JobAction.fetchBookmarksJob()).then(r => {
            setJobBookmarks(r)
            if (r?.length) {
                dispatch(HomeAction.addNotification({ treatments: r.length }))
            }
        })
    }, [dispatch])

    if (jobBookmarks?.length) {
        const jobs = jobBookmarks.filter(item => item.updateDate && item.jobType && item.name)
        return (
            <Stack>
                {
                    orderBy(jobs, 'updateDate', 'desc').slice(0, 5).map((jB, idx) => (
                        <Box
                            key={`${idx}_${jB.id}`}
                            sx={{
                                borderBottom: `1px solid ${GREY_BACKGROUND}`,
                                padding: 1,
                                transition: 'all 0.2s ease',
                                cursor: 'pointer',
                                '&:hover': {
                                    backgroundColor: GREY_BACKGROUND,
                                    borderLeft: '4px solid black',
                                    pl: 1,
                                },
                            }}
                            onClick={() => dispatch(push(`/import/${jB.id}`))}
                        >
                            <Grid container alignItems='center'>
                                <Grid size={2} textAlign='center'>
                                    <Typography fontWeight='bold'>
                                        {getFullDate(jB?.updateDate)}
                                    </Typography>
                                </Grid>
                                <Grid size={10}>
                                    <Typography
                                        variant='subtitle1'
                                        fontWeight='bold'
                                        noWrap
                                        sx={{ pl: 1 }}
                                    >
                                        {jB?.name}
                                    </Typography>
                                    <Typography
                                        variant='body2'
                                        noWrap
                                        sx={{ pl: 1 }}
                                    >
                                        {IMPORT_FORMATS().find(i => i.value === jB?.jobType).label ?? jB?.jobType}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    ))
                }
                <Box
                    sx={{
                        textAlign: 'center',
                        py: 1,
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: 'action.hover',
                        },
                    }}
                    onClick={() => dispatch(push('/job'))}
                >
                    <Typography
                        variant='body2'
                        color='primary'
                    >
                        {i18n.viewMore}
                    </Typography>
                </Box>
            </Stack>
        )
    }
    return <MessageCard>{i18n.noTreatmentsFavourites}</MessageCard>
}

export default NotifsTreatement